import { render } from "./NewChapterModal.vue?vue&type=template&id=1f139b64"
import script from "./NewChapterModal.vue?vue&type=script&lang=js"
export * from "./NewChapterModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__